import { Route, Switch as RRDSwitch, useRouteMatch } from 'react-router-dom';
import React from 'react';

import PrizesList from './features/PrizesList';
import NewPrize from './features/NewPrize';
import ExistingPrize from './features/ExistingPrize';

const Prizes = () => {
  const { path } = useRouteMatch();

  return (
    <RRDSwitch>
      <Route exact path={path}>
        <PrizesList />
      </Route>
      <Route path={`${path}/new`}>
        <NewPrize />
      </Route>
      <Route
        path={`${path}/:id`}
        render={({
          match: {
            params: { id },
          },
        }) => <ExistingPrize id={id?.trim()} />}
      />
    </RRDSwitch>
  );
};

export default Prizes;
